module.exports = __webpack_public_path__ + "static/media/profile-avatar.d0df05a5.png";